module.exports = ".dx-datagrid-headers {\r\n    color: #ffffff !important;\r\n    background-color: #003666 !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/messages/annoucements/annoucements.component.css
// module id = ./src/app/modules/dashboard/messages/annoucements/annoucements.component.css
// module chunks = dashboard.module